import React from 'react'

import { SearchResultsType } from '@monorepo/interfaces'
import {
  Search as SearchAPI,
  // useGoodSuggestion,
} from '@monorepo/deprecated/hooks'
import { Page } from 'App/Layout'
import { ProductsView } from './ProductsView'
import { Sidebar } from './Sidebar'

type PropsType = {
  result: SearchResultsType
}

export const Search: React.FC<PropsType> = () => {
  const {
    totalGoods,
    totalOffers,
    brandsMeta,
    // suggestions,
    result,
  } = SearchAPI.useResult()
  SearchAPI.useFetchResults()

  // const { handleChange } = useGoodSuggestion()
  // React.useEffect(() => {
  // handleChange()
  // })

  return (
    <Page title="Предложения" bottomSpace>
      <div className="block-split block-split--has-sidebar">
        <div className="container">
          {/* <div className="block-space block-space--layout--after-header" /> */}
          <div className="block-split__row row no-gutters">
            <Sidebar brandsMeta={brandsMeta} />
            <div className="block-split__item block-split__item-content col-auto">
              <div className="block">
                <ProductsView
                  result={result}
                  totalGoods={totalGoods}
                  totalOffers={totalOffers}
                />
              </div>
            </div>
          </div>
          {/* <div className="block-space block-space--layout--before-footer" /> */}
        </div>
      </div>
    </Page>
  )
}
